module.exports = __webpack_public_path__ + "static/media/levain_bg_img_3.97a56f73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/levain_bg_img_3.jpg
// module id = 1058
// module chunks = 0